import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=18441107"
import script from "./LoadData.vue?vue&type=script&lang=js"
export * from "./LoadData.vue?vue&type=script&lang=js"
import style0 from "./LoadData.vue?vue&type=style&index=0&id=18441107&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports